import * as React from 'react';
import { SuperAdminImportStudents } from './ImportStudents/SuperAdminImportStudents';
import { SuperAdminImportParents } from './ImportParents/SuperAdminImportParents';
import { SuperAdminImportStaff } from './ImportStaff/SuperAdminImportStaff';
import { SuperAdminActivateStudents } from './ActivateStudents/SuperAdminActivateStudents';
import { SuperAdminInvites } from './Invites/SuperAdminInvites';
import { SuperAdminArrangements } from './Arrangements/SuperAdminArrangements';
import { SuperAdminRegistrationDomains } from './RegistrationDomains/SuperAdminRegistrationDomains';
import { SuperAdminParentPermissions } from './ParentPermissions/SuperAdminParentPermissions';

const TABS = [
  'Import students',
  'Import parents',
  'Import staff',
  'Activate students',
  'Invites',
  'Arrangements',
  'Registration domains',
  'Update parent permissions'
];

interface State {
  currentTab: number;
}

export class SuperAdminTools extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = { currentTab: 0 };
  }

  renderCurrentTab() {
    switch (this.state.currentTab) {
      case 0:
        return <SuperAdminImportStudents />;
      case 1:
        return <SuperAdminImportParents />;
      case 2:
        return <SuperAdminImportStaff />;
      case 3:
        return <SuperAdminActivateStudents />;
      case 4:
        return <SuperAdminInvites />;
      case 5:
        return <SuperAdminArrangements />;
      case 6:
        return <SuperAdminRegistrationDomains />;
      case 7:
        return <SuperAdminParentPermissions />;
      default:
        return null;
    }
  }

  render() {
    const { currentTab } = this.state;
    return (
      <div className="container-fluid py-4">
        <div className="mb-3">
          <h2 className="mb-1">Tools</h2>
        </div>
        <ul className="nav nav-tabs mb-4">
          {TABS.map((tab, i) => {
            return (
              <li key={tab} className="nav-item">
                <a
                  className={`nav-link ${currentTab === i ? 'active' : ''}`}
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    this.setState({ currentTab: i });
                  }}
                >
                  {tab}
                </a>
              </li>
            );
          })}
        </ul>
        {this.renderCurrentTab()}
      </div>
    );
  }
}
